export default __webpack_public_path__ + "static/media/survey-insights-icon.442108a7.svg";